import React from 'react';
import { Card, CardBody, Button, Badge } from 'reactstrap';
import { H5, H6, P } from '../../../../AbstractElements';

const FieldCard = ({ field, onEdit, onDelete, onToggleStatus }) => {
  const getTypeBadge = (type) => {
    const badges = {
      text: { color: 'primary', icon: 'fa-font' },
      email: { color: 'info', icon: 'fa-envelope' },
      select: { color: 'success', icon: 'fa-list' },
      checkbox: { color: 'warning', icon: 'fa-check-square' },
      radio: { color: 'danger', icon: 'fa-dot-circle' },
      textarea: { color: 'secondary', icon: 'fa-align-left' },
      number: { color: 'info', icon: 'fa-hashtag' },
      date: { color: 'primary', icon: 'fa-calendar' }
    };
    const badge = badges[type] || { color: 'secondary', icon: 'fa-question' };
    
    return (
      <Badge color={badge.color}>
        <i className={`fa ${badge.icon} me-1`}></i>
        {type}
      </Badge>
    );
  };

  return (
    <Card className="shadow-sm border-0 mb-4">
      <CardBody className="p-4">
        <div className="d-flex justify-content-between align-items-start mb-3">
          <div className="flex-grow-1">
            <div className="d-flex align-items-center gap-2 mb-2">
              <Badge color="secondary" className="px-2">
                <i className="fa fa-sort-numeric-asc me-1"></i>
                #{field.fieldOrder}
              </Badge>
              {getTypeBadge(field.fieldType)}
              <Badge color={field.isActive ? 'success' : 'secondary'}>
                {field.isActive ? 'Active' : 'Inactive'}
              </Badge>
              {field.isRequired && (
                <Badge color="danger">
                  <i className="fa fa-star me-1"></i>
                  Required
                </Badge>
              )}
            </div>
            <H5 className="text-dark mb-1">{field.fieldLabel}</H5>
            <small className="text-muted">Field Name: {field.fieldName}</small>
          </div>
          <div className="d-flex gap-2">
            <Button 
              color="outline-primary" 
              size="sm"
              onClick={() => onEdit(field)}
            >
              <i className="fa fa-edit"></i>
            </Button>
            <Button 
              color="outline-danger" 
              size="sm"
              onClick={() => onDelete(field.id)}
            >
              <i className="fa fa-trash"></i>
            </Button>
          </div>
        </div>

        {/* Field Config */}
        {field.fieldConfig && Object.keys(field.fieldConfig).length > 0 && (
          <div className="mb-3 p-3 bg-light rounded">
            <H6 className="mb-2">Configuration:</H6>
            {field.fieldConfig.placeholder && (
              <P className="mb-1 small">
                <strong>Placeholder:</strong> {field.fieldConfig.placeholder}
              </P>
            )}
            {field.fieldConfig.options && (
              <div>
                <strong className="small">Options:</strong>
                <ul className="small mb-0 mt-1">
                  {field.fieldConfig.options.map((opt, idx) => (
                    <li key={idx}>{opt.label} ({opt.value})</li>
                  ))}
                </ul>
              </div>
            )}
            {(field.fieldConfig.minLength || field.fieldConfig.maxLength) && (
              <P className="mb-0 small">
                <strong>Length:</strong> {field.fieldConfig.minLength} - {field.fieldConfig.maxLength}
              </P>
            )}
          </div>
        )}

        {/* Validation Rules */}
        {field.validationRules && Object.keys(field.validationRules).length > 0 && (
          <div className="mb-3">
            <small className="text-muted">
              <i className="fa fa-shield me-1"></i>
              Validation: {Object.keys(field.validationRules).join(', ')}
            </small>
          </div>
        )}

        <div className="d-flex justify-content-between align-items-center">
          <small className="text-muted">
            {field.createdAt && `Created: ${new Date(field.createdAt).toLocaleDateString('vi-VN')}`}
          </small>
          <Button
            color={field.isActive ? 'warning' : 'success'}
            size="sm"
            onClick={() => onToggleStatus(field.id)}
          >
            <i className={`fa fa-${field.isActive ? 'eye-slash' : 'eye'} me-1`}></i>
            {field.isActive ? 'Tắt' : 'Bật'}
          </Button>
        </div>
      </CardBody>
    </Card>
  );
};

export default FieldCard;

